import React from "react";
import "./index.scss";
import Lookup from "devextreme-react/lookup";
import { IMdaeLookupProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
import { RequiredFieldLabel } from "../required-field-label";

const MdaeLookup: React.FC<IMdaeLookupProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className="sys-mdae-lookup-container">
      <Lookup
        {...props}
        searchEnabled={true}
        showClearButton={false}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_LOOKUP,
            e.component,
            dispatch
          );
        }}
      />
      {props.visible !== false && (
        <span className={"mdae-text-box-field-set-text"}>
          {props.mdaeLookupTitle}
          {props.required && <RequiredFieldLabel />}
        </span>
      )}
    </div>
  );
};
export default MdaeLookup;
